import React from 'react';
import PositiveToast from '@/components/toasts/PositiveToast';
import ToastMessage from '@/components/toasts/ToastMessage';

const TransferToast = ({ items, automatic }) => (
  <PositiveToast className="aridhia-transfer-toast">
    <ToastMessage
      items={items}
      multiple={automatic ? 'toast.transfers' : 'toast.completes'}
      single={automatic ? 'toast.transfer' : 'toast.completed'}
      identifiers={['request.name', 'request.code']}
    />
  </PositiveToast>
);

export default TransferToast;
